import { useTranslation } from "react-i18next";
import {
  QrCode,
  FileText,
  ClipboardList,
  CalendarClock,
  BarChart3,
  Globe,
  Bell,
  Users,
  Smartphone,
} from "lucide-react";
import ScrollReveal from "./ScrollReveal";

const features = [
  {
    icon: QrCode,
    titleKey: "features.qrcodes.title",
    descKey: "features.qrcodes.desc",
    title: "QR Codes intelligents",
    description:
      "Chaque machine est reliée à un QR code unique. Un simple scan ouvre le formulaire adapté à l'équipement et au contexte d'intervention.",
  },
  {
    icon: ClipboardList,
    titleKey: "features.forms.title",
    descKey: "features.forms.desc",
    title: "Formulaires dynamiques",
    description:
      "Créez des questionnaires hiérarchisés avec réponses libres, choix multiples ou oui/non.",
  },
  {
    icon: CalendarClock,
    titleKey: "features.planning.title",
    descKey: "features.planning.desc",
    title: "Planification intelligente",
    description:
      "Le système propose automatiquement des créneaux selon horaires, jours ouvrés et disponibilités.",
  },
  {
    icon: BarChart3,
    titleKey: "features.reports.title",
    descKey: "features.reports.desc",
    title: "Rapports automatisés",
    description:
      "À chaque intervention terminée, un rapport structuré est généré automatiquement et exportable en PDF.",
  },
  {
    icon: Bell,
    titleKey: "features.notifications.title",
    descKey: "features.notifications.desc",
    title: "Notifications en temps réel",
    description:
      "Les administrateurs, techniciens et clients sont notifiés à chaque étape importante.",
  },
  {
    icon: Users,
    titleKey: "features.roles.title",
    descKey: "features.roles.desc",
    title: "Gestion multi-rôles",
    description:
      "Administrez votre équipe avec des rôles distincts et des permissions adaptées.",
  },
  {
    icon: Smartphone,
    titleKey: "features.mobile.title",
    descKey: "features.mobile.desc",
    title: "Application mobile terrain",
    description:
      "Scan, diagnostic, saisie et soumission directement depuis l'application Android.",
  },
  {
    icon: Globe,
    titleKey: "features.languages.title",
    descKey: "features.languages.desc",
    title: "Support multilingue",
    description:
      "L'interface s'adapte dynamiquement à la langue de chaque utilisateur.",
  },
  {
    icon: FileText,
    titleKey: "features.history.title",
    descKey: "features.history.desc",
    title: "Historique & filtrage avancé",
    description:
      "Retrouvez n'importe quelle intervention passée grâce aux filtres par utilisateur, machine, date ou statut.",
  },
];

const AboutSection = () => {
  const { t } = useTranslation();

  return (
    <section className="assist-section">
      <div className="assist-container">
        <ScrollReveal className="assist-section-head">
          <p className="assist-section-eyebrow">{t("features.badge", "Fonctionnalités")}</p>
          <h2 className="assist-section-title">
            {t("features.title", "Tout ce qu'il faut pour digitaliser votre maintenance")}
          </h2>
          <p className="assist-section-text">
            {t(
              "features.subtitle",
              "Une plateforme complète qui couvre chaque étape, du scan QR à l'export du rapport final."
            )}
          </p>
        </ScrollReveal>

        <div className="assist-feature-grid">
          {features.map((item, i) => (
            <ScrollReveal key={item.titleKey} delay={i * 70}>
              <article className="assist-card assist-feature-card">
                <div className="assist-feature-icon">
                  <item.icon className="assist-icon" />
                </div>
                <h3 className="assist-feature-title">{t(item.titleKey, item.title)}</h3>
                <p className="assist-feature-text">{t(item.descKey, item.description)}</p>
              </article>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AboutSection;